<template>
  <div>
    <v-card v-if="businessRegistrationData">
      <v-card-title>
        <div>کسب و کار جدید</div>

        <v-spacer></v-spacer>
        <v-btn color="primary" @click="showCurrentMerchant()">
          مشاهده کسب و کار اصلی
        </v-btn>
        <v-btn color="error" icon @click="closeEditForm()">
          <v-icon>mdi mdi-close</v-icon></v-btn
        >
      </v-card-title>
      <v-card-text>
        <v-alert
          v-model="alert"
          border="left"
          close-text="Close Alert"
          color="primary"
          dark
          dismissible
          class="mx-15"
          outlined
        >
          کاربر گرامی، شما در حال افزودن یک کسب و کار جدید به مجموعه کسب و
          کارهای مرتبط خود هستید لطفاً اطلاعات کسب وکار اصلی را از طریق لینک
          مشاهده کسب و کار اصلی کنترل کنید و در صورت نیاز میتوانید کسب و کار
          دیگری را از لیست کسب و کارهای خود انتخاب کرده و بر اساس آن کسب و کار
          جدید ثبت کنید .
        </v-alert>
        <business-registration
          :businessRegistrationData="businessRegistrationData"
          @closeForm="closeEditForm"
          :addNewMerchantCompany="true"
        ></business-registration>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BusinessRegistration from '@/components/businessInformation/form/BusinessRegistration.vue';
export default {
  components: {
    BusinessRegistration,
  },
  data() {
    return {
      businessRegistrationData: null,
      alert: true,
    };
  },
  computed: {
    ...mapGetters(['currentMerchant']),
  },
  created() {
    if (this.currentMerchant) {
      this.getMerchantInformation();
    }
  },
  watch: {
    currentMerchant(after) {
      if (after) {
        this.getMerchantInformation();
      }
    },
  },
  methods: {
    showCurrentMerchant() {
      this.$router.push({
        path: `/merchant-companies/${this.currentMerchant}/information`,
      });
    },
    closeEditForm() {
      this.$router.push({
        path: '/merchant-companies/list',
      });
    },
    getMerchantInformation() {
      this.$store.dispatch('getMerchantInformation').then((data) => {
        this.businessRegistrationData = data;
      });
    },
  },
};
</script>

<style></style>
